import {TeamSeason} from './TeamSeason';
import {CompetitionSeason} from './CompetitionSeason';
import {Image} from './Image';
import {TopPlayer} from './TopPlayer';
import type {Iso8601DateString} from '@fupa/fupa-ts-core';

export enum TopElevenType {
  Weekly = 1,
  Yearly = 2,
  Custom = 3,
}

export interface TopEleven {
  readonly id: number;
  readonly matchDay?: number;
  readonly competition: CompetitionSeason | null;
  readonly votes: number;
  /** float */
  readonly quote: number;
  readonly views: number;
  readonly date: Iso8601DateString;
  readonly status: boolean;
  readonly type: TopElevenType;
  readonly backgroundImage: Image;
  readonly starting?: TopPlayer[];
  readonly substitutes?: TopPlayer[];
  readonly failedTeams?: TeamSeason[];
}
